import {useDroppable, useDndContext} from '@dnd-kit/core';
import classnames from 'classnames';

import {Illustration} from 'shells/illustrations/illustration';
import {Body} from 'shells/typography/body';

import {formEditorInsertDroppableId, isPaletteDragActive} from '../../drag-and-drop/helpers';

import styles from './field-insert-zone.module.css';

interface Props {
    pageIndex: number;
    index: number;
    fieldCreatePending?: boolean;
    isEmptyPage?: boolean;
}

export function FieldInsertZone(props: Props) {
    const {active} = useDndContext();
    const isSidebarDrag = active != null && isPaletteDragActive(active);
    const insertDropDisabled =
        Boolean(props.fieldCreatePending) || (Boolean(active) && !isSidebarDrag);

    const {setNodeRef, isOver} = useDroppable({
        id: formEditorInsertDroppableId(props.pageIndex, props.index),
        disabled: insertDropDisabled,
    });

    return (
        <div
            ref={setNodeRef}
            className={classnames(styles['zone'], {
                [styles['zone--empty-page']]: props.isEmptyPage,
                [styles['zone--empty-page-active']]: props.isEmptyPage && isOver && isSidebarDrag,
            })}
        >
            {props.isEmptyPage && (
                <>
                    <Illustration alt='' src='droppable-content-block' width={200} height={130} />
                    <Body color='medium' size='normal' textAlign='center'>
                        Drag and drop content blocks to this page
                    </Body>
                </>
            )}
            {!props.isEmptyPage && isOver && isSidebarDrag && (
                <div className={styles['indicator']} />
            )}
        </div>
    );
}
